import { Badge } from '@surein/ui'
import {
  AlertCircle,
  Archive,
  BarChart2,
  Loader,
  LucideIcon,
  Pause,
  X,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ContractStatus } from '@/types/insurance'

type ContractStatusBadgeProps = {
  status: ContractStatus
}

const IconToStatusMap: Record<ContractStatus, LucideIcon> = {
  aktiv: BarChart2,
  'transfer-initiated': BarChart2,
  antrag: Loader,
  review: Loader,
  validated: Loader,
  ablauf: Archive,
  storniert: X,
  ruhend: Pause,
  ablehnung: AlertCircle,
  'pending-cancellation': X,
  'confirmed-cancellation': X,
  archived: Archive,
  'contract-details-requested': Loader,
}

const StatusToVariantMap: Record<ContractStatus, string> = {
  aktiv: 'success',
  'transfer-initiated': 'success',
  antrag: 'warning',
  review: 'warning',
  validated: 'warning',
  ablauf: 'default',
  storniert: 'warning',
  ruhend: 'default',
  ablehnung: 'warning',
  'pending-cancellation': 'warning',
  'confirmed-cancellation': 'warning',
  archived: 'default',
  'contract-details-requested': 'warning',
}

const InternalStatusToCustomerStatusMap: Record<
  ContractStatus,
  ContractStatus
> = {
  aktiv: 'aktiv',
  'transfer-initiated': 'aktiv',
  antrag: 'antrag',
  review: 'antrag',
  validated: 'antrag',
  ablauf: 'ablauf',
  storniert: 'storniert',
  ruhend: 'ruhend',
  ablehnung: 'ablehnung',
  'pending-cancellation': 'storniert',
  'confirmed-cancellation': 'storniert',
  archived: 'archived',
  'contract-details-requested': 'antrag',
}

export const ContractStatusBadge = ({ status }: ContractStatusBadgeProps) => {
  const { t } = useTranslation()

  return (
    <Badge
      size="lg"
      isRounded
      variant={StatusToVariantMap[status]}
      icon={IconToStatusMap[status]}
    >
      {t(`contractStatuses.${InternalStatusToCustomerStatusMap[status]}`)}
    </Badge>
  )
}
